export const PlatformType = {
  IosDev: 'ios-dev',
  IosUat: 'ios-uat',
  IosRelease: 'ios-release',
  AndroidDev: 'android-dev',
  AndroidUat: 'android-uat',
  AndroidRelease: 'android-release',
  Web: 'web',
  Electron: 'electron'
}